import React, { useContext } from "react";
import { QueryClientProvider } from '@tanstack/react-query';
import { Auth0Provider } from "@auth0/auth0-react";
import AppRouter from "./router/AppRouter";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { AppContext } from "../src/AppContext/Context";
import { auth0ClientId, auth0Domain } from "./config";
import { queryClient } from './utils/queryClient';

// Component to monitor auth state and manage cache
// function AuthStateMonitor(): JSX.Element {
//   const { isAuthenticated, user, isLoading } = useAuth0();
//
//   useEffect(() => {
//     if (!isLoading) {
//       cacheManager.handleAuthStateChange(isAuthenticated, user);
//     }
//   }, [isAuthenticated, user, isLoading]);
//
//   return <></>;
// }

const App: React.FC = () => {
    const { isOpen, setIsOpen, isLoad } = useContext(AppContext);
    const client_id: string = auth0ClientId();
    const domain: string = auth0Domain();
    
    return (
        <QueryClientProvider client={queryClient}>
            <Auth0Provider
                domain={domain}
                clientId={client_id}
                authorizationParams={{
                    redirect_uri: window.location.origin,
                }}>
                <AppRouter />
            </Auth0Provider>
        </QueryClientProvider>
    );
};

export default App;

